module.exports = __webpack_public_path__ + "static/media/articleStoriesAccessibility.17e0770e.png";